export default function (values, field1, field2) {
    return values.reduce(function(sum, value) {
        if (value[field1]) {
            return sum + Number(value[field1]);
        }
        else if (value[field2]) {
            return sum + Number(value[field2]);
        }
        else {
            return sum;
        }
    }, 0);
};
